<template>
  <div class="full-height">
    <Row>
      <i-col :md="12" :xs="14">
        <p class="boldtext">{{ $t("Account") }}</p>
      </i-col>
      <i-col v-if="isOperatorOrAbove()" :md="12" :xs="10" class="text-right" align="right">
        <router-link :to="{ name: 'onboard-tenant' }">
          <button class="action-button" style="margin-right: 8px">
            <Icon type="md-briefcase" size="18" />
            {{ $t("Onboard a client") }}
          </button>
        </router-link>
        <button class="action-button" @click="triggerShowCreateModal">
          <Icon type="md-add" size="18" />
          {{ $t("Add account") }}
        </button>
        <ClientModalForm v-model="modalData" :modalOnSubmit="modalOnSubmit" :countryList="worldInfoStore.countryList"
          @hide="triggerHideModal" />
      </i-col>
    </Row>
    <transition appear name="slide-left-centered">
      <Table :columns="columns" :data="clients.results" ref="table" style="height: calc(700px)"
        class="s2ec-table accounts2" @on-row-click="open" :loading="isLoading">
        <template slot-scope="{ row }" slot="name">
          <strong style="margin: 40px">{{ row.name }}</strong>
        </template>
        <div slot="header" class="s2ec-table-header">
          <i-col :md="16" :xs="24">
            <Icon type="md-folder" size="27" class="icon" />
            {{ $t("All accounts") }}
          </i-col>
          <i-col v-if="isOperatorOrAbove()" :md="8" :xs="24" class="mt-3">
            <i-col :md="9" :xs="12" class="mr-3">
              <Input search type="text" v-model="clients.filter.name"
                @on-search="fetchClients({ client_name: clients.filter.name })" clearable @on-clear="fetchClients"
                :placeholder="$t('Search by name')" />
            </i-col>
            <i-col :md="8" :xs="8" class="mr-4">
              <i-select type="text" :placeholder="$t('Status')" v-model="clients.filter.status" clearable
                @on-change="fetchClients({ client_is_active: clients.filter.status })">
                <i-option value="true"> {{ $t('Active') }} </i-option>
                <i-option value="false"> {{ $t('Inactive') }} </i-option>
              </i-select>
            </i-col>
          </i-col>
        </div>
      </Table>
    </transition>
  </div>
</template>
<script>
import ClientModalForm from "@/views/accounts/modals/ClientModalForm";
import { getClientsQry, deleteClientQry, patchClientQry, postClientQry, putClientQry } from "@/services/accounts.service";
import AppModal from "@/components/common/AppModal"

/* FIXME REMOVE THIS OBSOLETE FILE */


export default {
  name: "Accounts",
  components: {
    ClientModalForm,
    getClientsQry,
    deleteClientQry,
    AppModal
  },
  data() {
    return {
      isLoading: false,
      clients: {
        results: [],
        count: 0,
        filter: {
          status: "",
          name: ""
        }
      },
      modalData: {
        showModal: false,
        form: {}
      },
      modalOnSubmit: null,
      columns: [
        {
          title: " ",
          slot: "view",
          width: 90,
          render: (h) => {
            return h("Button", {
              props: {
                icon: "ios-folder-open",
              },
              style: {
                border: "none",
                backgroundColor: "transparent",
                fontSize: "2rem"
              }
            });
          },
        },
        {
          title: this.$t("Name"),
          key: "client_name",
          sortable: true,
          align: "left",
        },
        { 
          title: this.$t("Status"),
          key: "client_status",
          sortable: true,
          align: "center",
          render: (h, params) => {
            if (params.row.client_is_active === false) {
              return h("div", {}, [
                h(
                  "p",
                  {
                    style: {
                      backgroundColor: "#D54848",
                      padding: "10px",
                      border: "none",
                      width: "80px",
                      margin: "auto",
                      height: "40px",
                      color: "white",
                      borderRadius: "5px",
                    },
                  },
                  this.$t("Inactive")
                ),
              ]);
            } else {
              return h("div", {}, [
                h(
                  "p",
                  {
                    style: {
                      backgroundColor: "#54AD77",
                      padding: "10px",
                      border: "none",
                      width: "80px",
                      margin: "auto",
                      height: "40px",
                      color: "white",
                      borderRadius: "5px",
                    },
                  },
                  this.$t("Active")
                ),
              ]);
            }
          },
        },
        {
          title: this.$t("Number of contracts"),
          key: "total_contracts",
          align: "center",
        },
        {
          title: this.$t("Actions"),
          key: "actions",
          width: "180",
          align: "center",
          render: (h, params) => {
            if (!this.isOperatorOrAbove()) return [];
            return [
              h("Button", {
                props: {
                  icon: "md-create",
                },
                attrs: {
                  title: this.$t("Edit")
                },
                class: "table-button",
                on: {
                  click: (evt) => {
                    evt.stopPropagation(); // "click.stop" is not supported here
                    this.triggerShowUpdateModal(params.row);
                  },
                },
              }),
              h("Button", {
                props: {
                  icon: params.row.client_is_active ? "md-close" : "md-done-all" ,
                },
                attrs: {
                  title: params.row.client_is_active ? this.$t("Disable") : this.$t("Enable")
                },
                class: "table-button",
                on: {
                  click: (evt) => {
                    evt.stopPropagation(); // "click.stop" is not supported here
                    this.changeStateAcccount(params.row.id, params.row.client_is_active);
                  },
                },
              }), 
              h("Button", {
                props: {
                  icon: "md-trash",
                },
                attrs: {
                  title: this.$t("Delete")
                },
                class: "table-button",
                on: {
                  click: (evt) => {
                    evt.stopPropagation(); // "click.stop" is not supported here
                    this.removeAccount(params.row.id, params.index);
                  },
                },
              }),

            ];
          },
        },
      ],
    };
  },
  computed: {
    emptyClientForm() {
      return {
        client_type: "",
        client_is_active: true,
        client_name: "",
        client_billing_address: "",
        client_billing_city: "",
        client_billing_country: "",
        client_contact_name: "",
        client_phone: "",
        client_email: "",
      }
    }
  },
  created() {
    this.modalData.form = { ...this.emptyClientForm }
    this.modalOnSubmit = this.triggerCreateClient

    this.fetchClients()
  },
  methods: {
    fetchClients(filter_value) {
      this.isLoading = true
      getClientsQry(filter_value)
        .then((res) => {
          this.clients.results = res.data.results;
          this.clients.count = res.data.count;
        })
        .catch(() => {
          this.$Message.error({
            content: this.$t("Error occurred retrieving clients"),
            duration: 5,
          })
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    open(row) {
      this.$router.push({
        name: "contracts",
        params: { id: row.id },
      });
    },
    removeAccount(id, idx) {
      this.$AppModal.AppConfirm({
        extraTitle: this.$t("Delete"),
        message: this.$t("You are about to delete this item. Are you sure to continue"),
        loading: true,
        cancelText: this.$t('Cancel'),
        onConfirm: (() => {
          deleteClientQry(id)
            .then(() => {
              this.clients.count -= 1;
              this.clients.results.splice(idx, 1);
              this.$AppModal.remove()
              this.$Message.success(this.$t("Successfully deleted your client"));
            })
            .catch(() => {
              this.$AppModal.remove()
              this.$Message.error({
                content: this.$t("Error occurred deleting your client"),
                duration: 5,
              });
            })
        })
      })
    },
    openAccount() {
      this.$router.push({
        name: "contracts",
        params: { id: params.row.id },
      });
    },
    changeStateAcccount(id, state) {
      patchClientQry(id, { client_is_active: !state })
        .then(() => {
          this.$Message.success(this.$t("Successfully updated a client"));
          setTimeout(() => {
            window.location.reload(); // FIXME NO SUCH RELOAD IN S.P.A
          }, 500)
        })
        .catch(() => {
          this.$Message.error({
            content: this.$t("Error occurred"),
            duration: 5,
          });
        })
    },
    triggerShowCreateModal() {
      this.modalData.form = { ...this.emptyClientForm }
      this.modalData.showModal = true;
      this.modalOnSubmit = this.triggerCreateClient
    },
    triggerShowUpdateModal(clientData) {
      this.modalData.form = { ...clientData }
      this.modalData.showModal = true
      this.modalOnSubmit = this.triggerUpdateClient
    },
    triggerHideModal() {
      this.modalData.form = { ...this.emptyClientForm }
      this.modalData.showModal = false
      this.modalOnSubmit = this.triggerCreateClient
    },
    triggerCreateClient() {
      const clientData = this.modalData.form

      postClientQry(clientData)
        .then(() => {
          this.$Message.success(this.$t("Successfully created your client"));
          this.fetchClients()
          this.triggerHideModal()
        })
        .catch(() => {
          this.$Message.error({
            content: this.$t("Error when adding a client"),
            duration: 5,
          });
        });
    },
    triggerUpdateClient() {
      const clientData = this.modalData.form

      putClientQry(clientData.id, clientData)
        .then(() => {
          this.$Message.success(this.$t("Successfully updated a client"))
          this.fetchClients()
          this.triggerHideModal()
        })
        .catch(() => {
          this.$Message.error({
            content: this.$t("Error when updating a client"),
            duration: 5,
          });
        });
    }
  },
};
</script>

<style>


.s2ec-table.accounts2 .ivu-table-title {
  margin-bottom: 42px !important;
}



.ivu-btn.ivu-btn-default.ivu-btn-icon-only {
  color: var(--secondary-color) !important;
}

.ivu-btn:focus {
  box-shadow: none;
}

.ivu-table-wrapper {
  border: 1px solid #edecff !important;
}
</style>
